import { render, staticRenderFns } from "./PlanComparisonModal.vue?vue&type=template&id=2bffac6c&"
import script from "./PlanComparisonModal.vue?vue&type=script&lang=js&"
export * from "./PlanComparisonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports